import { createContext, useEffect, useState } from 'react';

import { getUserFranchises } from 'services/openClaimService';

interface StoreListProviderProps {
  children: React.ReactNode;
}
export interface Franchise {
  cp: number;
  stores: [];
}

export const StoreListContext = createContext({} as Franchise);

const StoreListProvider = ({ children }: StoreListProviderProps) => {
  const [userFranchises, setUserFranchises] = useState({} as Franchise);

  useEffect(() => {
    async function fetchData() {
      const franchises = await getUserFranchises();
      setUserFranchises(franchises?.data.response);
    }
    fetchData();
  }, []);

  return (
    <StoreListContext.Provider value={userFranchises}>
      {children}
    </StoreListContext.Provider>
  );
};

export default StoreListProvider;
